import { render, staticRenderFns } from "./LabelStatementsList.vue?vue&type=template&id=d82cfbe2"
import script from "./LabelStatementsList.vue?vue&type=script&lang=js"
export * from "./LabelStatementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports